import { useState } from "react";
import Title from "../../components/common/title/Title";
import Button from "../../components/common/button/Button";
import { postApi, putApi } from "../../services/api/globalApi";
import { useLocation, useNavigate } from "react-router";
import {
  successMessage,
  errorMessage,
  warningMessage,
} from "../../utils/toastify-message/ToastifyMessage";

export default function AffiliateFaqForm() {
  const location = useLocation();
  const navigate = useNavigate();
  const isEdit = !!location.state;

  const [title, setTitle] = useState(location.state?.title || "");
  const [answer, setAnswer] = useState(location.state?.answer || "");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!title.trim()) return warningMessage("لطفا سوال را وارد کنید");
    if (!answer.trim()) return warningMessage("لطفا پاسخ را وارد کنید");

    setLoading(true);
    try {
      if (isEdit) {
        await putApi({
          path: `admin/affiliate-faq/${location.state._id}`,
          body: JSON.stringify({ title, answer }),
        });
        successMessage("سوال با موفقیت ویرایش شد");
      } else {
        await postApi({
          path: "admin/affiliate-faq",
          body: JSON.stringify({ title, answer }),
        });
        successMessage("سوال با موفقیت اضافه شد");
      }
      navigate("/affiliate-faq-list");
    } catch (error) {
      console.error(error);
      errorMessage("خطایی رخ داد");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <Title title={isEdit ? "ویرایش سوال نمایندگی" : "افزودن سوال نمایندگی"} />
      <form onSubmit={handleSubmit} className="mt-6 space-y-5">
        <div>
          <label className="block mb-1 text-sm font-medium text-gray-700 dark:text-gray-300">
            سوال
          </label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="متن سوال را وارد کنید"
            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm dark:bg-gray-800 dark:border-gray-600 dark:text-white focus:outline-none focus:ring-2 focus:ring-green-500"
          />
        </div>

        <div>
          <label className="block mb-1 text-sm font-medium text-gray-700 dark:text-gray-300">
            پاسخ
          </label>
          <textarea
            rows={5}
            value={answer}
            onChange={(e) => setAnswer(e.target.value)}
            placeholder="متن پاسخ را وارد کنید"
            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm dark:bg-gray-800 dark:border-gray-600 dark:text-white focus:outline-none focus:ring-2 focus:ring-green-500 resize-y"
          />
        </div>

        <Button
          text={loading ? "در حال ذخیره..." : isEdit ? "ویرایش" : "افزودن"}
          type="submit"
          color="success"
          disabled={loading}
        />
      </form>
    </div>
  );
}